import {feLogger, repType} from '.';

const reportIds = {
    clickShareBtn: '80001.1.175',
};

const logger = (repId: string, type: string, params?: any) => {
    try {
        const data = {
            rep_id: repId,
            rep_type: type,
            rep_params: params || {},
        };
        feLogger(data);
    } catch (e) {
        console.error(e);
    }
};

export const clickShareBtnLog = () => {
    return logger(reportIds.clickShareBtn, repType.Click);
};
